import { AD_FLAGS } from '../adsterra/adsterraConfig';

/**
 * Decides whether an ad break is allowed to show.
 * Premium users are always excluded.
 * Enforces cooldown and hourly cap.
 */
export class AdPolicy {
  constructor() {
    this._lastAdShownAt = 0;
    this._adsShownThisHour = 0;
    this._hourWindowStartedAt = Date.now();
  }

  /**
   * @param {{ isPremiumUser: boolean, completedSongCount: number }} params
   */
  canShowAdBreak({ isPremiumUser, completedSongCount }) {
    if (!AD_FLAGS.adsEnabled) return false;
    if (isPremiumUser) return false;
    if (completedSongCount < AD_FLAGS.adBreakThreshold) return false;

    const now = Date.now();

    // Reset hourly window if needed
    if (now - this._hourWindowStartedAt > 60 * 60 * 1000) {
      this._hourWindowStartedAt = now;
      this._adsShownThisHour = 0;
    }

    if (this._adsShownThisHour >= AD_FLAGS.maxAdBreaksPerHour) return false;
    if (now - this._lastAdShownAt < AD_FLAGS.adCooldownMs) return false;

    return true;
  }

  recordAdShown() {
    this._lastAdShownAt = Date.now();
    this._adsShownThisHour += 1;
  }
}
